(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["RP2"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function() {
  var sectionEl = document.querySelector(".related-products");
  if (!sectionEl) { return; }

  var request = new XMLHttpRequest();
  request.open("GET", sectionEl.dataset.url);

  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;

      var incoming = container.querySelector(".related-products");
      if (incoming) {
        sectionEl.innerHTML = incoming.innerHTML;
      }
    }
  };

  request.send();

  // fetch when section reloads in editor
  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      var editorSection = document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products');
      if (!editorSection) { return; }

      var editorRequest = new XMLHttpRequest();
      editorRequest.open("GET", editorSection.dataset.url);
      editorRequest.onload = function() {
        if (editorRequest.status >= 200 && editorRequest.status < 300) {
          var editorContainer = document.createElement("div");
          editorContainer.innerHTML = editorRequest.response;
          var editorIncoming = editorContainer.querySelector(".related-products");
          if (editorIncoming) {
            editorSection.innerHTML = editorIncoming.innerHTML;
          }
        }
      };
      editorRequest.send();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
